import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSignup } from "../../hooks/useSignup";
import "./signup.css";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { logoutUser } from "../../store/user/actions";
import { Button } from "antd";

import {
  userRoles as options,
  departmentOptions,
  countryOptions,
  roleAuditOptions
} from "../../data/data";

const Signup = () => {
  const user = useSelector(state => state.user);
  const [organizations, setOrganizations] = useState(null);
  const [organizationsField, setOrganizationsField] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [roleAudit, setRoleAudit] = useState("");
  const [organization, setOrganization] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [department, setDepartment] = useState("");
  const [country, setCountry] = useState("");
  const [showError, setShowError] = useState(false);
  const [masterEditor, setMasterEditor] = useState(false);
  const [EmailError, setEmailError] = useState(false);
  const [EmailValid, setEmailValid] = useState(false);
  const [PasswordError, setPasswordError] = useState(false);
  const dispatchito = useDispatch();
  const [filteredRoles, setFilteredRoles] = useState(options);

  //create login link
  const loginLink = `http://${process.env.REACT_APP_FILE_HOST}/regcom/login`
  // console.debug("++++INSIDE Signup.jsx, loginLink:", loginLink);

  //grab what we want from useLogin hook
  const { signup, error } = useSignup();

  const navigate = useNavigate();

  useEffect(() => {
    // setEmailError(false);
    if (error) {
      if(error=="Email is not valid and Password is not strong enough"){
        setEmailValid(true);
        setPasswordError(true);
      }
      if(error=="Email already in use"){
        setEmailError(true);
      }
      if (error=="Password is not strong enough"){
        setPasswordError(true);
      }
      if (error=="Email is not valid"){
        setEmailValid(true);
      }
      if (error!="Email already in use" && error!="Password is not strong enough" && error!="Email is not valid"){
        setShowError(true);
      }
    }
    else {
      setShowError(false);
      setEmailError(false);
      setPasswordError(false);
      setEmailValid(false);
    }
  }, [error]);

  //fetch organizations
  useEffect(() => {
      const fetchOrganizations = async () => {
        const response = await fetch("/api/organizations");
        //convert again json array of objects to javascript array of objects
        const json = await response.json();
        setOrganizations(json);
      };
  
      fetchOrganizations();
  }, []);

  //filter roles based on organization
  useEffect(() => {
    let allowedRoles = options;

    if (organization) {
      const selectedOrg = organizations.find(org => org._id === organization);

      if (
        selectedOrg &&
        (!selectedOrg.isPartOfGroup || selectedOrg.parentCompany)
      ) {
        allowedRoles = options.filter(
          role =>
            role.value !== "groupComplianceAssessor" &&
            role.value !== "groupComplianceObserver"
        );
      }
    }

    setFilteredRoles(allowedRoles);
  }, [organization, organizations]);

  let organizationOptions = [];

  //check if the role selected is groupComplianceAssessor
  if (
    (role === "groupComplianceAssessor" ||
      role === "groupComplianceObserver") &&
    organizations
  ) {
    organizationOptions = organizations
      .filter(org => org.isPartOfGroup && !org.parentCompany)
      .map(org => ({
        value: org._id,
        label: org.customerName
      }));
  } else if (organizations) {
    organizationOptions = organizations.map(org => ({
      value: org._id,
      label: org.customerName
    }));
  }

  //react-select handler
  const handleChange = selectedOption => {
    setRole(selectedOption.value);
    
    if(selectedOption.value ==="masterEditor"){
      console.debug("bike mesa ")
      setMasterEditor(true);
      setOrganization("");
      setOrganizationsField("");
    }else {
      setMasterEditor(false);
    }
    // console.debug(`Role Option selected:`, selectedOption);
  };

  const handleChangeOrganization = selectedOption => {
    setOrganization(selectedOption.value);
    setOrganizationsField(selectedOption);
    console.debug(`Organization Option selected:`, selectedOption.label);
  };

  const handleDepartmentChange = selectedOption => {
    setDepartment(selectedOption.value);
    // console.debug(`Department Option selected:`, selectedOption);
  };

  const handleCountryChange = selectedOption => {
    setCountry(selectedOption.value);
    // console.debug(`Country Option selected:`, selectedOption);
  };

  const handleRoleAuditChange = selectedOption => {
    setRoleAudit(selectedOption.value);
  };

  //handlers
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await signup(
        firstName,
        lastName,
        email,
        password,
        role,
        organization,
        department,
        country,
        loginLink,
        roleAudit
      );
      if (res) {
        // Check if status is 201
        console.debug("Signup successful, navigating to login page: (res)", res);
        navigate("/login"); // Navigate to the login page
      }
    } catch (error) {
      console.error("error from signup in Signup.jsx", error);
    }
  };

  return (
    <form className="signup" id="signup-page" onSubmit={handleSubmit}>
      <div id="formTitle">
        <p>Sign up</p>
      </div>
      <div id="firstRow">
        <div className="signupCol" id="signup-page-signupCol-1">
          <label id="labelFirstName">
            First Name <span style={{ color: "rgb(181, 4, 68)" }}>*</span>
          </label>

          <input
            id="inputFirstName"
            type="text"
            onChange={e => setFirstName(e.target.value)}
            value={firstName}
          />
        </div>
        <div className="signupCol" id="signup-page-signupCol-2">
          <label id="labelLastName">
            Last Name <span style={{ color: "rgb(181, 4, 68)" }}>*</span>
          </label>
          <input
            id="inputLastName"
            type="text"
            onChange={e => setLastName(e.target.value)}
            value={lastName}
          />
        </div>
      </div>

      <div id="secondRow">
        <div className="signupCol" id="signup-page-signupCol-3">
          <label id="labelDepartment">Department</label>
          <Select
            className="basic-single"
            id="signup-page-basic-single"
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: "#fff",
                border: "0.063rem solid #d0d5dd",
                boxShadow: "0rem 0.063rem 0.125rem rgba(16, 24, 40, 0.05)",
                borderRadius: "0.5rem",
                width: "21.563rem",
                fontSize: "1rem"
              }),
              option: base => ({
                ...base,
                fontSize: "1rem",
                textAlign: "left"
              }),
              input: styles => ({
                ...styles,
                height: "2.125rem",
                fontSize: "1rem"
              }),
              placeholder: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              }),
              valueContainer: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              }),
              singleValue: styles => ({
                ...styles,
                fontSize: "1rem"
              })
            }}
            options={departmentOptions}
            onChange={handleDepartmentChange}
          />
        </div>
        <div className="signupCol" id="signup-page-signupCol-4">
          <label id="labelCountry">Country</label>
          <Select
            className="basic-single"
            id="signup-page-basic-single-2"
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: "#fff",
                border: "0.063rem solid #d0d5dd",
                boxShadow: "0rem 0.063rem 0.125rem rgba(16, 24, 40, 0.05)",
                borderRadius: "0.5rem",
                width: "21.563rem",
                fontSize: "1rem"
              }),
              option: base => ({
                ...base,
                fontSize: "1rem",
                textAlign: "left"
              }),
              input: styles => ({
                ...styles,
                height: "2.125rem"
              }),
              placeholder: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              }),
              valueContainer: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              })
            }}
            options={countryOptions}
            onChange={handleCountryChange}
          />
        </div>
      </div>

      <div id="thirdRow">
        <div className="signupCol" id="signup-page-signupCol-5">
          <label id="labelEmail">
            Email <span style={{ color: "rgb(181, 4, 68)" }}>*</span>
          </label>
          <input
            id="inputEmail"
            onChange={e => {
              setEmail(e.target.value);
            }}
            value={email}
            autoComplete="new-password"
          />
          {EmailError ? (
            <>
              <span id="error-message-2">Email already in use</span>
            </>
          ) : EmailValid ? (
            <>
              <span id="error-message-2">Email is not valid</span>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="signupCol" id="signup-page-signupCol-6">
          <label id="labelPassword">
            Password <span style={{ color: "rgb(181, 4, 68)" }}>*</span>
          </label>
          <input
            id="inputPassword"
            type="password"
            onChange={e => setPassword(e.target.value)}
            value={password}
            autoComplete="new-password"
          />
          {PasswordError ? (
            <>
              <span id="error-message-3">Password is not strong enough</span>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div id="fourthRow">
        <div className="signupCol" id="signup-page-signupCol-7">
          <label id="labelRole">
            Role <span style={{ color: "rgb(181, 4, 68)" }}>*</span>
          </label>
          <Select
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: "#fff",
                border: "0.063rem solid #D0D5DD",
                boxShadow: "0rem 0.063rem 0.125rem rgba(16, 24, 40, 0.05)",
                borderRadius: "0.5rem",
                width: "21.563rem",
                fontSize: "1rem"
              }),
              option: base => ({
                ...base,
                fontSize: "1rem",
                textAlign: "left"
              }),
              input: styles => ({
                ...styles,
                height: "2.125rem"
              }),
              placeholder: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              }),
              valueContainer: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              })
            }}
            options={filteredRoles}
            onChange={handleChange}
          />
        </div>
        <div className="signupCol" id="signup-page-signupCol-8">
          <label id="labelOrganization">
            Organization <span style={{ color: "rgb(181, 4, 68)" }}>*</span>
          </label>
          <Select
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: "#fff",
                border: "0.063rem solid #D0D5DD",
                boxShadow: "0rem 0.063rem 0.125rem rgba(16, 24, 40, 0.05)",
                borderRadius: "0.5rem",
                width: "21.563rem",
                fontSize: "1rem"
              }),
              option: base => ({
                ...base,
                fontSize: "1rem",
                textAlign: "left"
              }),
              input: styles => ({
                ...styles,
                height: "2.125rem"
              }),
              placeholder: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              }),
              valueContainer: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              })
            }}
            id="signup-page-select"
            options={organizationOptions}
            isDisabled={masterEditor}
            value={organizationsField}
            onChange={handleChangeOrganization}
          />
        </div>
      </div>
      <div id="fifthRow">
        <div className="signupCol" id="signup-page-signupCol-9">
          <label id="labelRoleAudit">
            Audit Role
          </label>
          <Select
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: "#fff",
                border: "0.063rem solid #D0D5DD",
                boxShadow: "0rem 0.063rem 0.125rem rgba(16, 24, 40, 0.05)",
                borderRadius: "0.5rem",
                width: "21.563rem",
                fontSize: "1rem"
              }),
              option: base => ({
                ...base,
                fontSize: "1rem",
                textAlign: "left"
              }),
              input: styles => ({
                ...styles,
                height: "2.125rem"
              }),
              placeholder: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              }),
              valueContainer: styles => ({
                ...styles,
                fontSize: "1rem",
                textAlign: "left"
              })
            }}
            id="signup-page-select-roleAudit"
            options={roleAuditOptions}
            onChange={handleRoleAuditChange}
            isClearable={false}
          />
        </div>
        <div className="signupCol" id="signup-page-signupCol-10"></div>
      </div>
      <div id="backtologin">
        <a href="/regcom/login">« Back to Login</a>
      </div>
      {showError && !EmailError && !EmailValid ? (
        <>
          <span id="error-message">Some required fields are missing</span>
          <br></br>
          <br></br>
        </>
      ) : (
        <></>
      )}

      <Button onClick={handleSubmit}>Sign up</Button>
      {/* {error && <div className="error">{error}</div>} */}
      {/* {error && renderErrorModal()} */}
    </form>
  );
};

export default Signup;
